<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import Notices from './component.notices.svelte'
    import Notice from './component.notice.svelte'
    import NoticeCreate from './component.create.svelte'
    import NoticeUpdate from './component.update.svelte'

    if(!isPermission($adminStore, 'SettingsView.Notices.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Avisos" subtitle="Avisos y comunicados para usuarios" />
    <Notices />
</View>

<Modal id="notice_modal" title="Aviso">
    <Notice />
</Modal>

<Modal id="notice_create_modal" title="Crear aviso">
    <NoticeCreate />
</Modal>

<Modal id="notice_update_modal" title="Actualizar aviso">
    <NoticeUpdate />
</Modal>
